import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Analytics = ({
  size,
  type,
  theme,
  className,
  dataTestId = "analytics-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99987 0.166626C3.67227 0.166626 0.164062 3.67483 0.164062 8.00243C0.164062 12.33 3.67227 15.8382 7.99987 15.8382C12.3275 15.8382 15.8357 12.33 15.8357 8.00243C15.8357 3.67483 12.3275 0.166626 7.99987 0.166626ZM7.33203 1.53384C4.05456 1.86821 1.4974 4.63669 1.4974 8.00243C1.4974 11.5936 4.40865 14.5049 7.99987 14.5049C11.1548 14.5049 13.7849 12.2581 14.3774 9.27729L7.93582 8.66699C7.59352 8.63456 7.33203 8.34712 7.33203 8.00329V1.53384ZM14.5021 7.9498C14.4961 7.19364 14.3611 6.46821 14.1179 5.79448L10.4433 7.56526L14.5021 7.9498ZM13.5383 4.5937C12.5032 2.91544 10.7266 1.74314 8.66536 1.5336V6.94199L13.5383 4.5937Z"
    />
  </SVGIcon>
);
